// galleryPlugin.js
export default function (md) {
    function isGalleryStart(line) {
        return /^:::\s*gallery(?:\s|$)/.test(line.trim());
    }

    function parseHeader(line) {
        // erlaubt:
        // :::gallery columns=3
        // ::: gallery columns=3
        // :::gallery columns="3"
        // ::: gallery columns='3'

        const trimmed = line.trim();
        const rest = trimmed.replace(/^:::\s*gallery\b/, "").trim();

        const attrs = {};
        const re = /(\w+)=(".*?"|'.*?'|[^\s]+)/g;
        let m;

        while ((m = re.exec(rest))) {
            let v = m[2];

            if (
                (v.startsWith('"') && v.endsWith('"')) ||
                (v.startsWith("'") && v.endsWith("'"))
            ) {
                v = v.slice(1, -1);
            }

            if (v === "true") v = true;
            else if (v === "false") v = false;
            else if (!Number.isNaN(Number(v)) && v.trim() !== "") v = Number(v);

            attrs[m[1]] = v;
        }

        return attrs;
    }

    function parsePipeMetaFromAlt(altRaw) {
        // "file.webp|width=600|height=280|aspectRatio=15/7"
        const parts = (altRaw || "")
            .split("|")
            .map((s) => s.trim())
            .filter(Boolean);

        const alt = parts.shift() ?? "";
        const meta = {};

        for (const p of parts) {
            const eq = p.indexOf("=");
            if (eq === -1) continue;

            const k = p.slice(0, eq).trim();
            let v = p.slice(eq + 1).trim();

            if (v !== "" && !Number.isNaN(Number(v))) v = Number(v); // aspectRatio bleibt String
            meta[k] = v;
        }

        return { alt, meta };
    }

    function galleryBlock(state, startLine, endLine, silent) {
        const start = state.bMarks[startLine] + state.tShift[startLine];
        const max = state.eMarks[startLine];
        const firstLine = state.src.slice(start, max);

        if (!isGalleryStart(firstLine)) return false;
        if (silent) return true;

        // finde closing :::
        let nextLine = startLine + 1;
        let found = false;

        while (nextLine < endLine) {
            const s = state.bMarks[nextLine] + state.tShift[nextLine];
            const e = state.eMarks[nextLine];
            const l = state.src.slice(s, e).trim();

            if (l === ":::") {
                found = true;
                break;
            }

            nextLine++;
        }

        if (!found) return false;

        const header = parseHeader(firstLine);

        // Start
        let tok = state.push("gallery_open", "", 1);
        tok.block = true;
        tok.meta = header;

        // Inhalt tokenizen
        const innerStart = startLine + 1;
        const innerEnd = nextLine;
        state.md.block.tokenize(state, innerStart, innerEnd);

        // Ende
        tok = state.push("gallery_close", "", -1);
        tok.block = true;

        state.line = nextLine + 1;
        return true;
    }

    md.block.ruler.before("fence", "gallery_container", galleryBlock, {
        alt: ["paragraph", "reference", "blockquote", "list"],
    });

    // Collapse: gallery_open..gallery_close -> ein Token "gallery" mit images[]
    md.core.ruler.push("collapse_gallery", (state) => {
        const tokens = state.tokens;
        const out = [];

        for (let i = 0; i < tokens.length; i++) {
            const t = tokens[i];

            if (t.type !== "gallery_open") {
                out.push(t);
                continue;
            }

            const columns = t.meta?.columns ?? 3;
            const images = [];

            i++;
            for (; i < tokens.length; i++) {
                const cur = tokens[i];
                if (cur.type === "gallery_close") break;

                if (cur.type === "inline" && cur.children) {
                    for (const c of cur.children) {
                        if (c.type !== "image") continue;

                        const src = c.attrGet("src") || "";
                        const altRaw = c.content || c.attrGet("alt") || "";
                        const { alt, meta } = parsePipeMetaFromAlt(altRaw);

                        images.push({
                            src,
                            alt,
                            width: meta.width,
                            height: meta.height,
                            aspectRatio: meta.aspectRatio,
                        });
                    }
                }
            }

            const g = new state.Token("gallery", "", 0);
            g.block = true;
            g.attrs = [
                ["columns", String(columns)],
                ["images", JSON.stringify(images)],
            ];
            out.push(g);
        }

        state.tokens = out;
    });
}